// Charge la base commune
require('./common.js')

// Styles librairies
import 'owl.carousel/dist/assets/owl.carousel.min.css'

// Styles custom
import './scss/pages/credit'

// Scripts librairies
import 'script-loader!waypoints/lib/jquery.waypoints.min.js'
import 'owl.carousel'

// Pages
//var agenciesPage = require('exports-loader?agenciesPage!./js/pages/agencies.page.js')

// Components
async function getSimulators($f) {
  const { default: _ } = await import('lodash')
  import('./js/components/simulators.js').then(module => {
    $f.css({opacity: '1'}).find('input, select, button').prop('disabled', false).niceSelect('update')
  })
}

// actions principales communes à toutes les pages
$(document).ready(function() {

  // gestion des simulateurs
  var $f = $('form.simulator')
  if ( $f.length ) {
    var waypoints = $f.waypoint(function(direction) {
      $f.css({opacity: '0.5'}).find('input, select, button').prop('disabled', true).niceSelect('update')
      getSimulators($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des carousel
  $('div.owl-carousel').each(function() {
    var slider = $(this),
        options = (typeof $(this).attr('data-plugin-options') !== typeof undefined && $(this).attr('data-plugin-options') !== false) ? $(this).attr('data-plugin-options').replace(/\'/g, '\"') : { },
        defaults = {
          items: 1,
          lazyLoad: true,
          autoplay: true,
          autoplayTimeout: 4000,
          margin: 30,
          autoplayHoverPause: true,
          loop: true
        }
    if ( options.length > 0 ) {
      var obj = JSON.parse(options),
          config = $.extend({}, defaults, obj)
      slider.owlCarousel(config)
    } else {
      slider.owlCarousel(defaults)
    }
  })

})
